import { createRoot } from 'react-dom/client';
import { AppRoot } from './AppRoot';
import '@wegic/ui/dist/arco-adapter';
import './style/index.less';
import './index.css';

createRoot(document.getElementById('root')).render(<AppRoot />);
